import {Component, Input} from '@angular/core';
import {isEmpty} from 'lodash';
import {OnfidoUser} from '../../../api/entity';


@Component({
    selector: 'tfl-bo-onfido-client-user',
    template: `
        <div class="x_panel">
            <div class="x_title">
                <h4>{{ onfidoUser.userName }}</h4>

                <tfl-bo-onfido-status-badge
                    [status]="onfidoUser.onfidoStatus"
                    class="pull-right">
                </tfl-bo-onfido-status-badge>
            </div>
            <div class="x_content">
                <div>
                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CREATE_DATE_TIME' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ onfidoUser.createDateTime }}</div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.APPLICANT_ID' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ onfidoUser.applicantId }}</div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.EMAIL' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ onfidoUser.email }}</div>
                    </div>
                </div>

                <ng-container *ngIf="!isEmptyCheckList()">
                    <hr/>

                    <h4>{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.CHECKS' | translate }}:</h4>

                    <div class="verification-results-block-inner" *ngFor="let check of onfidoUser.checks">
                        <tfl-bo-onfido-verification-check [check]="check"></tfl-bo-onfido-verification-check>
                    </div>
                </ng-container>
            </div>
        </div>
    `
})
export class ClientUserOnfidoVerificationComponent {

    @Input() onfidoUser: OnfidoUser;

    isEmptyCheckList() {
        return isEmpty(this.onfidoUser.checks);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/results/client-user.onfido.verification.component.ts